import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { Form, Select } from '@/pages/profile/blocks';
import { mapItems } from '@/tools/mapitems';

@Component({
  components: {
    Form,
    Select,
  },
  mixins: [validationMixin],
})
export default class PagesProfileProgressMixin extends Vue {
  get state() {
    return this.$store.state;
  }

  get competitionLevel() {
    const { nokoCompetitionLevels } = this.state;
    return mapItems(nokoCompetitionLevels);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/views/progress/forms/mixin/index.ts